<template>
    <b-card>
        <div class="d-flex align-items-center justify-content-center">
            <div class="person-photo">
                <img :src="person.photo" class="rounded" height="120" alt="" v-if="!!person.photo">
                <img src="images/avatar_empty.png" height="120" v-else alt="">
            </div>
            <div class="person-info d-flex">
                <table class="table table-sm">
                    <tbody>
                        <tr>
                            <td><strong>Nombre</strong></td>
                            <td>{{ person.name }}</td>
                        </tr>
                        <tr>
                            <td><strong>Documento</strong></td>
                            <td>{{ person.document }}</td>
                        </tr>
                        <tr>
                            <td><strong>E-mail</strong></td>
                            <td>{{ person.email }}</td>
                        </tr>
                        <tr>
                            <td><strong>Teléfono</strong></td>
                            <td>{{ person.phone }}</td>
                        </tr>
                        <tr>
                            <td><strong>Notas</strong></td>
                            <td>{{ person.notes }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>  
        </div>
    </b-card>
</template>
<script>
export default {
    props: {
        person: {
            type: Object,
            required: true
        }
    }
}
</script>